import produce from "immer";
import { TixlyActions, UPDATE_BASKET_COUNT, UPDATE_LOGGED_IN_STATUS } from "./actions";

export interface TixlyState {
    basket: {
        count: number;
    };
    loggedIn: boolean;
}
const initialState: TixlyState = {
    basket: {
        count: 0
    },
    loggedIn: false
};

export const getBasketCount = (state: TixlyState) =>  state?.basket?.count ?? 0; 
export const getLoggedInStatus = (state: TixlyState) => state?.loggedIn ?? false;

export const reducer = (tixlyState = initialState, action: TixlyActions): TixlyState => produce(tixlyState, draft =>
{
    switch (action.type) {
        case UPDATE_BASKET_COUNT:
            draft.basket.count = action.count;
            break;
        case UPDATE_LOGGED_IN_STATUS:
            draft.loggedIn = action.loggedIn;
            break;
    }
});

export default reducer;